import { SharedAppState } from 'containers/shared'
import { POI, POIType } from 'generated/mos/poi'
import { DataStatus as GenericDataStatus, EntityStatus as GenericEntityStatus, Status } from 'helpers/status'

type POIErrorCode = string

export type DataStatus<T> = GenericDataStatus<T, POIErrorCode>
export type EntityStatus<T extends object> = GenericEntityStatus<T, POIErrorCode, string>

export type POIEdit = POI.Entity;

export type POIsList = ReadonlyArray<POI.Entity>;
export type POITypesList = ReadonlyArray<POIType.Entity>

export interface POIFilterState {
  readonly search?: string;

  // FIXME: Docs dead-end. Where do I look to find out what keys I might find in here?
  readonly expanded: Record<string, boolean>;

  readonly lastEdited?: POI.Ref;
}

export type POIsAppState = {
  readonly poiFilters: POIFilterState;
  readonly poiCreate: DataStatus<POI.Ref>;

  // poiEdit contains the result of retrieving a single poi for the
  // purpose of editing it. It does not represent the intermediate state.
  readonly poiEdit: EntityStatus<POIEdit>;

  readonly pois: DataStatus<POIsList>;
  readonly poiTypes: DataStatus<POITypesList>;
};

export const initialPOIsAppState: POIsAppState = {
  poiFilters: { search: '', expanded: {} },
  poiCreate: { status: Status.Idle },
  poiEdit: { status: Status.Idle },
  pois: { status: Status.Idle },
  poiTypes: { status: Status.Idle },
}

export type POIsStore = {
  readonly pois: POIsAppState;
  readonly shared: SharedAppState;
}
